export default "__VITE_ASSET__DP1Ue5Sp__"